import type { Catalog } from './runtime';

/** Immutable, same-origin assets; failed HTTP/JSON loads are never cached here. */
export async function fetchCatalog(url: string): Promise<Catalog> {
  const response = await fetch(url, { credentials: 'same-origin' });
  if (!response.ok) throw new Error('Catalog download failed');
  const catalog: unknown = await response.json();
  if (!catalog || typeof catalog !== 'object' || Array.isArray(catalog) ||
      Object.values(catalog).some(message => typeof message !== 'string' &&
        (!message || typeof message !== 'object' || Array.isArray(message) ||
         typeof (message as { other?: unknown }).other !== 'string' ||
         Object.values(message).some(value => typeof value !== 'string')))) {
    throw new Error('Invalid catalog');
  }
  return catalog as Catalog;
}
